import type { Reducer } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import { loadDeviceActivityAsync } from "@/base/farmhq-api"
import type { CenterPivotPlanEntry } from "@/redux/models"

import type { RootState } from "./root.reducer"

export interface CenterPivotPlansState {
  /**
   * Active (status=PENDING) plans keyed by `centerPivotId`. The backend
   * enforces at most one PENDING plan per pivot via a partial unique
   * index, so a flat keyed map is sufficient.
   */
  byCenterPivotId: Record<number, CenterPivotPlanEntry>
}

const initialState: CenterPivotPlansState = {
  byCenterPivotId: {},
}

const slice = createSlice({
  name: "centerPivotPlans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      loadDeviceActivityAsync.fulfilled,
      (state, { payload }) => {
        const incoming = payload.activePivotPlans
        if (!incoming) return
        const next: Record<number, CenterPivotPlanEntry> = {}
        for (const plan of incoming) {
          next[plan.centerPivotId] = plan
        }
        state.byCenterPivotId = next
      },
    )
  },
})

export const selectActivePlanForCenterPivot = (
  state: RootState,
  centerPivotId: number | null | undefined,
): CenterPivotPlanEntry | undefined => {
  if (centerPivotId == null) return undefined
  return state.centerPivotPlans.byCenterPivotId[centerPivotId]
}

const centerPivotPlans: Reducer<CenterPivotPlansState> = slice.reducer
export default centerPivotPlans
